import { IPhxStateService } from 'utility-ng-configuration';
import { TransferDegreeCompletionQuery } from './../../queries/transfer_degree_completion_query';
import { ICommand } from 'core-ts-types';
import { Major } from '../../builders/major_builder';
import { IMemberDatasource, MemberDatasource } from './../../../global/datasources/member_datasource';
import { TransferCreditsProgressState } from '../../progression/transfer_credits_progress_state';
import { DegreeCompletion } from '../../builders/degree_completion_builder';

export interface MajorDetailsTabName {
  name: 'degree' | 'courses' | 'careers' | 'about' | 'equivalent';
  label: string;
}

export class TransferMajorDetailsController {
  // TODO add interface to biz-ng-career-details
  private relatedCareers: any;
  private equivalentCourse: any;

  model: {
    config: IMemberDatasource;
  };
  tabs: MajorDetailsTabName[];
  activeTab: MajorDetailsTabName;
  shouldDisplayAdditionalColumns: boolean;

  constructor(
    private $state: IPhxStateService,
    private ngMemberDatasource: MemberDatasource,
    private ngTransferDegreeCompletionQuery: TransferDegreeCompletionQuery,
    private major: Major,
    private loadTransferMajorRelatedCareersCommand: ICommand,
    private loadTransferMajorEquivalentCoursesCommand: ICommand,
    private ngTransferCreditsProgressState: TransferCreditsProgressState
  ) {
    this.model = {
      config: ngMemberDatasource.read()
    };

    loadTransferMajorRelatedCareersCommand(this.major.id).then((res) => {
      this.relatedCareers = res;
    });

    loadTransferMajorEquivalentCoursesCommand(this.major.id).then((res) => {
      this.equivalentCourse = res;
    });
  }

  $onInit() {
    const commonTabs: MajorDetailsTabName[] = [
      {
        name: 'degree',
        label: 'Degree Completion'
      },
      {
        name: 'careers',
        label: 'Related Careers'
      },
      {
        name: 'about',
        label: 'About the Major'
      }
    ];
    
    const conditionalTab: MajorDetailsTabName = this.shouldDisplayEQCourseTab() 
      ? { name: 'equivalent', label: 'Equivalent Courses' }
      : { name: 'courses', label: 'Courses Not Applied' };
    
    this.tabs = [...commonTabs.slice(0, 1), conditionalTab, ...commonTabs.slice(1)];
    this.activeTab = { ...this.tabs[0] };
    this.shouldDisplayAdditionalColumns = this.enableAdditionalCourseInfo();
  }

  get degreeCompletion(): DegreeCompletion {
    return this.ngTransferDegreeCompletionQuery.result[this.major.id];
  }

  displayOtherCreditsHeading() {
    return !_.isEmpty(this.equivalentCourse.exams)
  }

  private shouldDisplayEQCourseTab() {
    return this.model.config.core_config.enable_course_equivalency_view;
  }

  private enableAdditionalCourseInfo() {
    return this.model.config.core_config.enable_additional_course_info;
  }

  selectedIndexEnded($event: any) {
    const index = $event.detail.value;
    if (index === null) {
      return;
    }
    this.activeTab = this.tabs[index];
  }

  isActiveTab(tabName: MajorDetailsTabName['name']): boolean {
    return tabName === this.activeTab.name;
  }

  setActiveTab(tabName: MajorDetailsTabName['name']): void {
    this.activeTab.name = tabName;
  }

  closeModal(): ng.IPromise<any> {
    return this.$state.__goToPrevious__();
  }

  print(): void {
    window.print();
  }
}

angular.module('capability-ng-transfer').controller('ngTransferMajorDetailsController', TransferMajorDetailsController);



// WEBPACK FOOTER //
// ./app/lib/transfer/views/major_details/major_details.ts